import { Fragment, useMemo } from 'react';
import { defineBlock } from '@smartfire/js-block-engine';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Share from '../components/share';
import TableOfContents from './table-of-contents';
import { ReactComponent as Decoration } from './decoration.svg';
import style from './block.module.scss';

function ArchiveGuides({ guides = [], categories = [], currentGuide = null }) {
    const breadcrumbs = [
        <Link underline="hover" key="1" color="inherit" href="/">
            Home
        </Link>,
        <Typography key="2" color="text.primary">
            Guides
        </Typography>,
    ];

    const guide = useMemo(() => {
        if (guides.length === 0) return null;
        return currentGuide
            ? guides.find((element) => element && element.id === currentGuide)
            : categories.length > 0
            ? guides.find((element) => element && element.category === categories[0].id)
            : null;
    }, [guides, categories, currentGuide]);

    return (
        <Fragment>
            <Decoration className={style.decoration} />
            <div className={style.archiveGuides}>
                <div className={style.breadcrumbs}>
                    <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                        {breadcrumbs}
                    </Breadcrumbs>
                </div>
                {guides && categories ? (
                    <div className={style.contentPart}>
                        <TableOfContents categories={categories} guides={guides} currentGuide={guide && guide.id} />
                        <div className={style.rightPart}>
                            {guide && (
                                <Fragment>
                                    <div className={style.topGuide}>
                                        <h1 dangerouslySetInnerHTML={{ __html: guide.title }} />
                                        <Share />
                                    </div>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: guide.content,
                                        }}
                                        className={style.content}
                                    />
                                </Fragment>
                            )}
                        </div>
                    </div>
                ) : (
                    <p className={style.admin}>Liste des guides</p>
                )}
            </div>
        </Fragment>
    );
}

export default defineBlock({
    Block: ArchiveGuides,
    smartProps: {},
    setup: {
        title: 'Guides',
    },
});
